import {NgModule} from '@angular/core';
import {MaterialModule} from './material.module';
import {ShowForCustomerDirective} from './directives/show-for-customer.directive';
import {ShowForNonCustomerDirective} from './directives/show-for-non-customer.directive';
import {QueryParamsBuilder} from './query-params/query-builder';
import {ShowByStatusDirective} from './directives/show-by-user-and-status';
import {PipeModule} from './pipes/pipes.module';
import {DynamicService} from './services/dynamic.service';
import {DynamicListResolver, DynamicEditResolver, DynamicNewResolver} from './services/dynamic-resolvers.service';
import {StorageService} from './services/storage.service';
import {ShowForAdminDirective} from '@shared/directives/show-for-admin.directive';
import {AddForRankDirective} from '@shared/directives/add-for-rank.directive';
import {ShowForRankDirective} from '@shared/directives/show-for-rank.directive';
import {DynamicListComponent} from '@shared/dynamic/dynamic-list/dynamic-list.component';
import {DynamicSearchComponent} from '@shared/dynamic/dynamic-search/dynamic-search.component';
import {DynamicTableComponent} from '@shared/dynamic/dynamic-table/dynamic-table.component';
import {CommonModule} from '@angular/common';
import {ActionButtonsComponent} from '@shared/dynamic/action-buttons/action-buttons.component';
import {CustomSelectComponent} from '@shared/dynamic/custom-select/custom-select.component';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {LocalToUtcPipe} from '@shared/pipes/local-to-utc.pipe';
import {UtcToLocalPipe} from '@shared/pipes/utc-to-local.pipe';
import {BackButtonComponent} from '@shared/dynamic/back-button/back-button.component';
import { KeyboardNavigationDirective } from '@shared/directives/keyboard-navigation.directive';
import { SelectAllOnFocusDirective } from './directives/select-all-on-focus.directive';
import { CalendarAppModule } from './calendar/calendar.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        MaterialModule,
        PipeModule,
        CommonModule,
        FormsModule,
        TranslateModule,
        CalendarAppModule,
        MatDialogModule
    ],
  declarations: [
    ShowForCustomerDirective,
    ShowByStatusDirective,
    ShowForAdminDirective,
    ShowForNonCustomerDirective,
    AddForRankDirective,
    KeyboardNavigationDirective,
    ShowForRankDirective,
    DynamicListComponent,
    DynamicSearchComponent,
    DynamicTableComponent,
    ActionButtonsComponent,
    CustomSelectComponent,
    BackButtonComponent,
    SelectAllOnFocusDirective,
  ],
  providers: [
    QueryParamsBuilder,
    DynamicService,
    DynamicListResolver,
    DynamicEditResolver,
    LocalToUtcPipe,
    UtcToLocalPipe,
    DynamicNewResolver,
    StorageService,
  ],
  exports: [
    MaterialModule,
    ShowForCustomerDirective,
    ShowByStatusDirective,
    ShowForAdminDirective,
    ShowForNonCustomerDirective,
    KeyboardNavigationDirective,
    AddForRankDirective,
    ShowForRankDirective,
    PipeModule,
    DynamicListComponent,
    DynamicTableComponent,
    ActionButtonsComponent,
    CustomSelectComponent,
    BackButtonComponent,
    CalendarAppModule,
    SelectAllOnFocusDirective,
    MatDialogModule,
  ]
})
export class SharedModule {
}
